import React, { useEffect, useState } from "react";
import PanelHead from "../../../Panel/PanelHead";
import PanelBody from "../../../Panel/PanelBody";
// import { FormEditEmployee } from "./FormEditEmployee";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";
import FormEditTelegramGroup from "./FormEditTelegramGroup";

export const PanelEditTelegramGroup = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [Panels, setPanels] = useState([]);
  const [data, setData] = useState({
    title: "",
    url: "",
    owner: "",
    owner_panel: "",
    active: 1,
  });

  const get_panels = async () => {
    const { response } = await Helper.Get({
      url: api_Routes.Groups.PanelView,
      hasToken: true,
    });
    if (response) {
      setPanels(response);
      setIsLoading(false);
    }
  };

  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.Groups.TelegramGetOne}${id}`,
      });

      if (response) {
        setData({
          title: response.data.title || "",
          url: response.data.url || "",
          owner: response.data.owner || "",
          owner_panel: response.data.owner_panel || "",
          active: response.data.active ? 1 : 0,
        });
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      get_panels();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      {" "}
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              Edit Telegram group <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>Edit Telegram group: {data?.title}</div>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? (
            <LinearProgress />
          ) : (
            <FormEditTelegramGroup data={data} setData={setData} Panels={Panels} loading={isLoading} />
          )
        }
      />
    </div>
  );
};
